import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Box, Tooltip, IconButton, CircularProgress } from '@mui/material';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import styles from './MetricCard.module.css';

const MetricCard = ({ title, value, delta, infoText = "", loading = false }) => {
    const hasValue = value !== null && value !== undefined;
    const hasDelta = delta !== null && delta !== undefined;
    const isPositive = hasDelta ? delta >= 0 : true;
    const deltaValue = hasDelta ? Math.abs(delta) : 0;
    
    const badgeBg = isPositive ? '#00B1901A' : '#FFEEED';
    const badgeColor = isPositive ? '#09967C' : '#D54C48';
    const badgeBorder = isPositive ? '1px solid #00B190' : '1px solid #FFBBB9';
    const sign = isPositive ? '+' : '-';

    return (
        <Card className={styles.card}
        style={{
            boxShadow: 'none',
            borderRadius: '8px',
            position: 'relative',
        }}
        >
            <CardContent className={styles.cardContent}>
                <Box className={styles.header}>
                    <Typography className={styles.title}>{title}</Typography>
                    <Tooltip title={infoText} arrow>
                        <IconButton size="small" className={styles.infoIcon}>
                            <IoMdInformationCircleOutline />
                        </IconButton>
                    </Tooltip>
                </Box>

                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '48px' }}>
                        <CircularProgress size={24} sx={{ color: '#4D5F6E' }} />
                    </Box>
                ) : (
                <Box className={styles.body}>
                    <Typography className={styles.value}>
                        {hasValue ? (<>{Number(value).toFixed(2)}<span className={styles.percent}>%</span></>) : '—'}
                    </Typography>
                    
                    {hasDelta && (
                    <Box className={styles.badgeContainer}>
                        <Typography className={styles.ytdLabel}
                        style={{
                            marginBottom: '6px'
                        }}
                        >YTD Δ</Typography>
                        <Box 
                            className={styles.badge}
                            style={{ 
                                backgroundColor: badgeBg, 
                                color: badgeColor,
                                border: badgeBorder
                            }}
                        >
                            {sign}{deltaValue}%
                        </Box>
                    </Box>
                    )}
                </Box>
                )}
            </CardContent>
        </Card>
    );
};

MetricCard.propTypes = {
    title: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    delta: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    infoText: PropTypes.string,
    loading: PropTypes.bool,
};

export default MetricCard;
